import { createContext } from "react";

const defaultContext = {isMobile: false, isTablet: false };

export const ResponsiveContext = createContext(defaultContext);
